import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import { translate as t } from '../../lib/I18n';
import OrderTrip from '../../records/order/Trip';

import Price from '../general/Price';
import PureRenderComponent from '../PureRenderComponent';


class TripPlusbus extends PureRenderComponent {

    static propTypes = {
        orderTrip: PropTypes.instanceOf(OrderTrip).isRequired,
        open: PropTypes.bool
    };

    static defaultProps = {
        open: false
    };

    _renderItem (group, name) {
        const total = group.reduce((result, fare) => result + fare.getTotalPrice(), 0);
        const passengers = group.reduce((result, fare) => result + fare.adults() + fare.children(), 0);

        return (
            <li key={ name } className="clearfix text-weight--normal plusbus-list__item">
                <div className="price pull-right"><Price price={ total } /></div>
                <span>{ passengers } x { name } <span className="plusbus__name">{ t('order.summary.plusbus') }</span></span>
            </li>
        );
    }

    render () {
        const { orderTrip } = this.props;

        if (!orderTrip.hasPlusBus()) { return null; }

        const fares = orderTrip.getPlusBus().getFares();
        const groups = fares.groupBy((fare) => fare.origin.name);

        const classNames = classnames('fare-plusbus padding-top--sm margin-bottom--sm border-thick--top also-visible-print');

        return (
            <div className={ classNames }>
                <ul className="plusbus-list padding-top--sm list-unstyled">
                    { groups.map(this._renderItem).toList() }
                </ul>
            </div>
        );
    }

}


export default TripPlusbus;
